/* import __COLOCATED_TEMPLATE__ from './discovery-banner.hbs'; */
/* RESPONSIBLE TEAM: team-channels */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';

export default class EmailDiscoveryBanner extends Component {
  @service declare intl: IntlService;
  @service declare intercomEventService: any;

  @action
  showBannerArticle(articleId: number, eventObject: string) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: eventObject,
      place: 'settings_channels_email',
      section: 'domains_and_addresses_discovery_banner',
    });
    window.Intercom('showArticle', articleId);
  }

  @action
  showBannerConnectToEmailArticle() {
    this.showBannerArticle(9744849, 'banner_connect_to_email');
  }

  @action
  showBannerDeployFinAiOverEmailArticle() {
    this.showBannerArticle(9356221, 'banner_deploy_fin_ai_over_email');
  }

  get bannerLinks() {
    return [
      {
        id: 'connect-to-email',
        text: this.intl.t(
          'new-settings.channels.email.discovery-banner.learn-articles.connect-to-email',
        ),
        onSelectItem: this.showBannerConnectToEmailArticle,
        href: 'https://www.intercom.com/help/en/articles/9744849-connect-your-email-support-channel',
      },
      {
        id: 'deploy-fin-ai-over-email',
        text: this.intl.t(
          'new-settings.channels.email.discovery-banner.learn-articles.deploy-fin-ai-over-email',
        ),
        onSelectItem: this.showBannerDeployFinAiOverEmailArticle,
        href: 'https://www.intercom.com/help/en/articles/9356221-deploy-fin-ai-agent-over-email',
      },
    ];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Channels::Email::DiscoveryBanner': typeof EmailDiscoveryBanner;
    'new-settings/channels/email/discovery-banner': typeof EmailDiscoveryBanner;
  }
}
